import preferences from "@coworker/enums/profilePreferences";
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";

const DEFAULT_MEDIA_TYPE_TAB = "allMedia";

export function usePersistedMediaTypeTab() {
  const [selectedMediaTypeTab, setPersistedTab] = useUserPreference<string>(
    preferences.MEDIA_OVERVIEW_TAB,
    DEFAULT_MEDIA_TYPE_TAB
  );

  const setSelectedMediaTypeTab = (tabId: string) => {
    if (tabId !== selectedMediaTypeTab) {
      setPersistedTab(tabId);
    }
  };

  return {
    selectedMediaTypeTab,
    setSelectedMediaTypeTab,
  };
}
